import { createSelector, Selector } from '@ngrx/store';
import { AppState } from '../appstate';
import { PersonRecord } from '../generated/person-record.generated';
import { UnitPositionRecord } from '../generated/unit-position-record.generated';
import { selectAllPeople, selectAllUnitPostions } from './entity-store-selectors';

export function selectPersonById(id: string): Selector<AppState, PersonRecord | undefined> {
  return createSelector(selectAllPeople, (v) => v.get(id));
}

export function selectPersonByEmail(email: string): Selector<AppState, PersonRecord | undefined> {
  return createSelector(selectAllPeople, (v) => {
    email = email.toLowerCase();
    return v.find((p) => p.email.toLowerCase() === email);
  });
}

export function selectPersonByEmployeeId(
  employeeId: string,
): Selector<AppState, PersonRecord | undefined> {
  return createSelector(selectAllPeople, (v) => {
    return v.find((p) => p.employeeId === employeeId);
  });
}

export function selectPeopleFlightComplianceAsReady() {
  return createSelector(selectAllPeople, (people) => {
    return people
      .valueSeq()
      .filter((p) => people.find((up) => up.isOutOfFlightCompliance === false) == null);
  });
}

export function selectPeopleNotAssignedToUnitPosition() {
  return createSelector(selectAllPeople, selectAllUnitPostions, (people, positions) => {
    return people
      .valueSeq()
      .filter((p) => positions.find((up) => up.teamMemberId === p.id) == null);
  });
}

export function selectPeopleAssignedToUnit(unitId: string) {
  return createSelector(selectAllUnitPostions, selectAllPeople, (positions, people) => {
    return (
      positions
        .valueSeq()
        .filter((p) => p.unitId === unitId && p.teamMemberId != null)
        .map((p: UnitPositionRecord) =>
          p.teamMemberId == null ? undefined : people.get(p.teamMemberId),
        )
        .filter((p) => p != null)
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        .map((p) => p!)
    );
  });
}

export function selectPeople() {
  return createSelector(selectAllPeople, (people) => {
    return people.valueSeq();
  });
}
